module.exports = __webpack_public_path__ + "img/water-level0-1.ec1dfe7b.png";